document.addEventListener("DOMContentLoaded", async function () {
  let uploadedFile = null;

  // Get elements
  const photoCanvas = document.getElementById("photoCanvas");
  const messageCanvas = document.getElementById("messageCanvas");
  const photoCtx = photoCanvas.getContext("2d");
  const messageCtx = messageCanvas.getContext("2d");

  const photoModal = document.getElementById("photo-modal");
  const personalizePhotoBtn = document.getElementById("personalize-photo-btn");
  const customImageInput = document.getElementById("customImage");
  const photoPreview = document.getElementById("photo-preview");
  const savePhotoBtn = document.getElementById("save-photo");
  const closePhotoModal = document.getElementById("close-photo-modal");

  const messageModal = document.getElementById("message-modal");
  const writeDedicationBtn = document.getElementById("write-dedication-btn");
  const customMessageInput = document.getElementById("customMessage");
  const saveMessageBtn = document.getElementById("save-message");
  const closeMessageModal = document.getElementById("close-message-modal");

  // Default Dedication Message
  const childName = (await loadProfile())?.name || "Name"; // Fallback in case it's not set
  const defaultTextTemplate =
    "Dear [Name],\n\nYou have brought such joy and wonder to our lives. We hope that you find the same joy and happiness, wherever your life takes you.";

  const defaultText = defaultTextTemplate.replace("[Name]", childName);

  // Background Images
  const photoPageImage = new Image();
  const messagePageImage = new Image();
  const rawPhotoUrl =
    "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Photo.png?v=1747810832";
  const rawMessageUrl =
    "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Message.png?v=1747810832";

  photoPageImage.crossOrigin = "anonymous";
  messagePageImage.crossOrigin = "anonymous";

  photoPageImage.src = rawPhotoUrl;
  messagePageImage.src = rawMessageUrl;

  // Helper to set high-resolution canvas
  function setupHighResCanvas(canvas, ctx, scaleFactor = 4.4) {
    const displayWidth = canvas.width;
    const displayHeight = canvas.height;

    canvas.width = displayWidth * scaleFactor;
    canvas.height = displayHeight * scaleFactor;
    canvas.style.width = displayWidth + "px";
    canvas.style.height = displayHeight + "px";

    ctx.scale(scaleFactor, scaleFactor);
  }

  // Set high-resolution canvas rendering
  setupHighResCanvas(photoCanvas, photoCtx);
  setupHighResCanvas(messageCanvas, messageCtx);

  // Show cross button after image preview
  // customImageInput.addEventListener("change", function () {
  //   const file = this.files[0];
  //   if (file) {
  //     uploadedFile = file;

  //     const reader = new FileReader();
  //     reader.onload = function (e) {
  //       photoPreview.src = e.target.result;
  //       photoPreview.style.display = "flex";
  //       document.getElementById("remove-photo").style.display = "flex";

  //       // Save DataURL for preview only (not used for API)
  //       localStorage.setItem("customPhoto", e.target.result);
  //       localStorage.setItem("photoUploaded", "true");
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // });

  customImageInput.addEventListener("change", function () {
    const file = this.files[0];

    if (file) {
      const maxSizeInBytes = 3 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        return;
      }

      uploadedFile = file;

      const reader = new FileReader();
      reader.onload = async function (e) {
        photoPreview.src = e.target.result;
        photoPreview.style.display = "flex";
        document.getElementById("remove-photo").style.display = "flex";

        // Save DataURL for preview only
        const profile = await loadProfile();
        await saveProfile({...profile, imageBase64 : e.target.result });
      };
      reader.readAsDataURL(file);
    }
  });

  // Remove uploaded image
  document
    .getElementById("remove-photo")
    .addEventListener("click", async function () {
      photoPreview.src = "";
      photoPreview.style.display = "none";
      this.style.display = "none";
      customImageInput.value = "";
      const profile = await loadProfile();
      await saveProfile({...profile, imageBase64 : '' });
    });

  // Message character validation
  customMessageInput.addEventListener("input", function () {
    const maxLength = 150;
    const errorContainer = document.getElementById("message-error");

    if (this.value.length > maxLength) {
      errorContainer.textContent =
        "Your message must not exceed 150 characters.";
      saveMessageBtn.disabled = true;
    } else {
      errorContainer.textContent = "";
      saveMessageBtn.disabled = false;
    }
  });

  // Function to Load Photo Page
  function loadPhotoPage(imageSrc = null) {
    photoCtx.clearRect(0, 0, photoCanvas.width, photoCanvas.height);
    photoCtx.drawImage(photoPageImage, 0, 0, 580, 580);

    if (imageSrc) {
      const uploadedImage = new Image();
      uploadedImage.src = imageSrc;
      uploadedImage.onload = function () {
        const size = 250; // Target display size
        const x = 200; // Adjusted X position
        const y = 100; // Adjusted Y position

        // Get the aspect ratio of the uploaded image
        const imgRatio = uploadedImage.width / uploadedImage.height;
        const targetRatio = 1;

        let cropWidth, cropHeight, cropX, cropY;

        if (imgRatio > targetRatio) {
          cropHeight = uploadedImage.height;
          cropWidth = cropHeight * targetRatio;
          cropX = (uploadedImage.width - cropWidth) / 2;
          cropY = 0;
        } else {
          cropWidth = uploadedImage.width;
          cropHeight = cropWidth / targetRatio;
          cropX = 0;
          cropY = (uploadedImage.height - cropHeight) / 2;
        }

        // Draw cropped image to fit the box
        photoCtx.drawImage(
          uploadedImage,
          cropX,
          cropY,
          cropWidth,
          cropHeight, // Crop area
          x,
          y,
          size,
          size // Target position & size
        );
      };
    }
  }

  // Function to Draw Text with New Lines & Spaces Preserved
  function drawMultilineText(ctx, text, x, y, maxWidth, lineHeight) {
    const lines = text.split("\n"); // Preserve line breaks
    lines.forEach((line, index) => {
      let words = line.split(" ");
      let currentLine = "";
      words.forEach((word) => {
        let testLine = currentLine + word + " ";
        let testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth && currentLine !== "") {
          ctx.fillText(currentLine, x, y);
          y += lineHeight;
          currentLine = word + " ";
        } else {
          currentLine = testLine;
        }
      });
      ctx.fillText(currentLine, x, y);
      y += lineHeight;
    });
  }

  // Function to Load Message Page
  function loadMessagePage(text = defaultText) {
    messageCtx.clearRect(0, 0, messageCanvas.width, messageCanvas.height);
    messageCtx.drawImage(messagePageImage, 0, 0, 580, 580);

    messageCtx.font = "20px Georgia";
    messageCtx.fillStyle = "#64625F";
    messageCtx.textAlign = "center";
    messageCtx.textBaseline = "top";

    const maxWidth = 400; // Set max width for text wrapping
    const x = 310; // Adjusted for alignment
    const y = 180; // Adjusted vertical position
    const lineHeight = 30;

    drawMultilineText(messageCtx, text, x, y, maxWidth, lineHeight);
  }

  // Open and Close Modals
  personalizePhotoBtn.onclick = () => (photoModal.style.display = "flex");
  closePhotoModal.onclick = () => (photoModal.style.display = "none");
  writeDedicationBtn.onclick = () => (messageModal.style.display = "flex");
  closeMessageModal.onclick = () => (messageModal.style.display = "none");

  // Handle Image Upload
  // customImageInput.addEventListener("change", function () {
  //   const file = this.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = function (e) {
  //       photoPreview.src = e.target.result;
  //       photoPreview.style.display = "block";
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // });

  // Save Photo
  function getResizedImageDataURL(tempImage, maxWidth = 1100, maxHeight = 1100) {
        const originalWidth = tempImage.width;
        const originalHeight = tempImage.height;
      
        let targetWidth = originalWidth;
        let targetHeight = originalHeight;
      
        // Only resize if the image is larger than max dimensions
        if (originalWidth > maxWidth || originalHeight > maxHeight) {
          const widthRatio = maxWidth / originalWidth;
          const heightRatio = maxHeight / originalHeight;
          const scaleFactor = Math.min(widthRatio, heightRatio);
      
          targetWidth = originalWidth * scaleFactor;
          targetHeight = originalHeight * scaleFactor;
        }
      
        // Create export canvas
        const exportCanvas = document.createElement("canvas");
        exportCanvas.width = targetWidth;
        exportCanvas.height = targetHeight;
      
        const exportCtx = exportCanvas.getContext("2d");
        exportCtx.drawImage(tempImage, 0, 0, targetWidth, targetHeight);
      
        const dataUrl = exportCanvas.toDataURL("image/png");
        return dataUrl;
      }
  
  savePhotoBtn.addEventListener("click", async function () {
    const previewSrc = photoPreview.getAttribute('src');
    if (previewSrc) {
      const profile = await loadProfile();
      await saveProfile({...profile, imageBase64 : previewSrc });

      const tempImage = new Image();
      tempImage.crossOrigin = "anonymous";
      tempImage.src = previewSrc;

      tempImage.onload = async function () {
        // 1. Display 250x250 preview
        loadPhotoPage(previewSrc);

        // 2. Save original image at its full resolution
        const dataUrl = getResizedImageDataURL(tempImage);
        await saveProfile({...profile, imageBase64 : dataUrl });
      };
    }
    else {
      loadPhotoPage(null);
    }

    photoModal.style.display = "none";
  });

  // Save Message
  saveMessageBtn.addEventListener("click", async function () {
    const dedicationText = customMessageInput.value;
    const profile = await loadProfile();
    await saveProfile({...profile, dedicationText: dedicationText });
    loadMessagePage(dedicationText);
    messageModal.style.display = "none";
    // console.log("Custom Message to send:", dedicationText);
  });

  // Load Saved Data on Page Load
  photoPageImage.onload = async () =>
    loadPhotoPage((await loadProfile())?.imageBase64 || null);
  messagePageImage.onload = async () => {
    const profile = await loadProfile();
    const storedMessage = profile?.dedicationText;
    const childName = profile?.name || "Name";
    const defaultTextTemplate =
      "Dear [Name],\n\nYou have brought such joy and wonder to our lives. We hope that you find the same joy and happiness, wherever your life takes you.";

    // If message not saved yet, personalize and save it
    if (!storedMessage) {
      const personalized = defaultTextTemplate.replace("[Name]", childName);
      const profile = await loadProfile();
      await saveProfile({...profile, dedicationText: personalized })
      loadMessagePage(personalized);
    } else {
      loadMessagePage(storedMessage);
    }
  };

  // Restore image preview in photo modal
  const profile = await loadProfile();
  const isValidUpload = Boolean(profile?.imageBase64);
  if (savedPhoto && isValidUpload) {
    photoPreview.src = savedPhoto;
    photoPreview.style.display = "block";
    document.getElementById("photo-preview-container").style.display = "flex";
    document.getElementById("upload-area").style.display = "none";
    document.getElementById("remove-photo").style.display = "flex";
  }

  // Restore saved message in the message modal textarea
  const savedMessage = profile?.dedicationText;
  customMessageInput.value = savedMessage || defaultText;
});
